import {
  SecondhandTaxesLandingPageSection,
  NO_CHANGES_TO_TAXES_IMAGE_BASE_URL,
} from '../../constants'

const getFactsSectionCards = (countryCode = 'UK', isDarkMode = false, cardNumbers = 3) => {
  const darkModePrefix = isDarkMode ? 'dark' : 'light'
  const getFactImageUrl = (itemOrder: number) =>
    `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-illustration-facts-${itemOrder}-194x124-${darkModePrefix}`

  return Array.from({ length: cardNumbers }, (_, index) => index + 1).map(itemOrder => {
    const imageUrl = getFactImageUrl(itemOrder)

    return {
      text: {
        caption: `secondhand_taxes.facts.item${itemOrder}.caption`,
        title: `secondhand_taxes.facts.item${itemOrder}.title`,
      },
      image: {
        src: `${imageUrl}.png`,
        srcSet: `${imageUrl}.png 1x, ${imageUrl}@2x.png 2x, ${imageUrl}@3x.png 3x,`,
      },
    }
  })
}

export const getFactsSectionContent = (
  countryCode = 'UK',
  isDarkMode = false,
  cardNumbers = 3,
) => ({
  componentId: SecondhandTaxesLandingPageSection.Facts,
  testId: 'no-changes-to-taxes--facts-section',
  text: {
    title: 'secondhand_taxes.facts.title',
  },
  cards: getFactsSectionCards(countryCode, isDarkMode, cardNumbers),
})
